/**
 * 弹窗选配模块
 * 
 */

async function openPopUpBuy(config) {
  const Dialog = await window.$ACE.get('popupBuy', 'aliyun-config.component-version');
  await Dialog.init(config);
}
async function configSelect(config, product, resolve) {
  const Dialog = await window.$ACE.get('popupBuy', 'aliyun-config.component-version');
  await Dialog.initConfigSelect(config, async ({ components }) => {
    product.setValue(components, true);
    await product.setValueWithConstranit();
    resolve(components);
  });
}
export { openPopUpBuy, configSelect };


// WEBPACK FOOTER //
// ./lib/services/services/popupBuy.js